<section class="section_one">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <!-- desktop table view open-->
                <div class="ibox">
                    <!-- <form [formGroup]="myGroup" > -->
                    <div>
                        <div class="ibox-title report_flexweb">
                            <div>
                                <h5 class="addcamera"> Add Camera</h5>
                            </div>
                            <div>
                                <figure>
                                    <img src="../../assets/image/baseline-close.svg" (click)="employesid()" />
                                </figure>
                            </div>
                        </div>
                        <div class="card">

                            <div class="card">
                                <div>
                                    <p class="campus-name">Campus Name</p>
                                    <mat-select class="form_select">
                                        <input type="text" class="matInput" matInput [formControl]="campusControl"
                                            [matAutocomplete]="auto">
                                        <mat-autocomplete #auto="matAutocomplete"></mat-autocomplete>
                                        <mat-option *ngFor="let item of filteredCampuses | async " [value]="item"
                                            (click)="onCampusChange(item)">
                                            {{ item.campusName }}
                                        </mat-option>
                                    </mat-select>
                                </div>
                                <div>
                                    <p class="campus-name">Building Name</p>
                                    <mat-select class="form_select">
                                        <input type="text" class="matInput" matInput [formControl]="buildingControl"
                                            [matAutocomplete]="auto2">
                                        <mat-autocomplete #auto2="matAutocomplete"></mat-autocomplete>
                                        <mat-option *ngFor="let building of filteredBuildings |async" [value]="building"
                                            (click)="onbuilding(building)">
                                            {{ building.buildingName }}
                                        </mat-option>
                                    </mat-select>
                                </div>
                                <!-- DROP ZONE -->
                                <div cdkDropList class="dropzone" (cdkDropListDropped)="onItemDropped($event)">
                                    Drop Here
                                </div>

                                <!-- DRAGGABLE CAMERA LIST -->
                                <div class="cameras1">
                                    <ng-container *ngFor="let camera of cctvcameralist?.cameraDetails">
                                        <figure cdkDrag [cdkDragData]="camera" class="cctv" style="position: relative; z-index: 1000;">

                                            <img [src]="camera.cctvFrameS3Url" class="cameras" alt="Camera frame"
                                                (click)="openDialog(camera)" />

                                            <p class="buliding-name" (click)="openDialog(camera)">
                                                {{ cctvcameralist.buildingName }}
                                            </p>
                                        </figure>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- </form> -->
                    <!-- desktop table view close-->
                </div>
            </div>
        </div>
    </div>
</section>